import React from 'react'
import { ServiceInformationProps } from '@/modules/Service/types'
import { useTranslation } from 'react-i18next'
import { Settings } from 'lucide-react'

const Setting: React.FC<ServiceInformationProps> = () => {
    const { t } = useTranslation(['services'])

    return (
        <div className="flex items-center justify-center p-8 bg-slate-50 rounded-md border border-slate-200 mt-2">
            <div className="text-center">
                <Settings className="h-12 w-12 text-slate-300 mx-auto mb-3" />
                <p className="text-lg font-medium text-slate-500 mb-1">
                    {t('services:no_config', {
                        defaultValue: 'Không có cấu hình',
                    })}
                </p>
                <p className="text-sm text-slate-400">
                    {t('services:no_config_desc', {
                        defaultValue:
                            'Dịch vụ này không có cấu hình có thể chỉnh sửa',
                    })}
                </p>
            </div>
        </div>
    )
}

export default Setting
